export function getRandomValues(array: any[]) {
  let r: number = 0;
  for (let i = 0; i < array.length; i++) {
    if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
    array[i] = (r >>> ((i & 0x03) << 3)) & 0xff;
  }

  return array;
}
